import type { ColumnWidthThresholds } from '@/components/ui/responsiveColumns';

/**
 * Which Leads table columns drop out as the table container narrows, widest threshold
 * first. Card mode (below `md`) ignores this list and shows every column.
 *
 * Lead Source goes at the same width as Origin, after Facility and Plan Type. With the nav,
 * avatar rail and filter sidebar all open, a desktop table is 900–1000px wide, and when Lead
 * Source was the second column to go (below 1200px) nobody saw it. UTM Source sits beside
 * Lead Source and goes with it.
 *
 * Lives outside LeadsPage.tsx so the test can import the real value without mounting the page.
 */
export const LEAD_COLUMN_THRESHOLDS: ColumnWidthThresholds = [
  [1400, 'message'],
  [1200, 'planTypeName'],
  [1100, 'facilityName'],
  [900, 'leadSourceName'],
  [900, 'utmSource'],
  [900, 'leadFrom'],
  [800, 'subject'],
];
